import * as React from "react"
import { observer } from "mobx-react"

import { Box, useTheme } from "@mui/material"
import { useTecDocStore } from "api/services/TecDoc"
import { useMemo } from "react"
import List, { ListTextItemTypes } from "pages/TecDoc/components/List"
import { groupListByValue } from "pages/util"
import ListHeading from "pages/TecDoc/components/List/components/ListHeading"
import { useTranslation } from "react-i18next"

export const namespace = __filename

const OE: React.FC = () => {
  const tecDocStore = useTecDocStore()
  const { oeNumber } = tecDocStore
  const theme = useTheme()
  const { t } = useTranslation()

  const oeLinkages = useMemo(() => {
    let tempOeLinkages: ListTextItemTypes[] = []
    if (oeNumber) {
      tempOeLinkages = oeNumber.map((item) => {
        return {
          brand: item.brandName,
          key: item.oeNumber,
          subItems: [
            {
              label: item.oeNumber,
              content: "",
            },
          ],
        }
      })
    }

    return Object.entries(groupListByValue(tempOeLinkages, "brand")).map(
      (item) => {
        return (
          <List
            type={"TEXT"}
            key={item[0]}
            title={item[0]}
            items={item[1]}
            accordion={true}
          />
        )
      }
    )
  }, [oeNumber])

  return (
    <Box className="oe-container">
      <Box sx={{ paddingBottom: theme.spacing(2) }}>
        <ListHeading title={t("oe")} caret={"NONE"} variant={"PRIMARY"} />
      </Box>
      <Box
        sx={{ display: "flex", flexDirection: "column", gap: theme.spacing(1) }}
      >
        {oeLinkages}
      </Box>
    </Box>
  )
}

export default observer(OE)
